import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { useTranslation } from 'react-i18next'
import { VehiclePlansIcon } from './VehiclePlansArea/VehiclePlansIcon'
import { VehiclePlansAreaRoutes } from './VehiclePlansAreaRoutes'

export const VehiclePlansAreaNavigationIcon = VehiclePlansIcon

export const VehiclePlansAreaNavigation = ({
  onClick,
  open,
}: AreaNavigationProps) => {
  const { t } = useTranslation()
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={t('vehiclePlans_title')}
      to={VehiclePlansAreaRoutes.route}
      Icon={VehiclePlansIcon}
    />
  )
}
